export default __webpack_public_path__ + "static/media/Central_Protocol.45564511.jpg";